import { CollectionDetail } from '@shared/api/types';
import Text from '@shared/components/content/text';
import { useOutletContext } from 'react-router-dom';
import AverageLifeCycleEmissions from '../../dashboard/components/average-life-cycle-emissions';
import ProductRatingsBreakdown from '../../dashboard/components/product-ratings-breakdown';
import CollectionDashboardHeader from '../../dashboard/sections/collection-dashboard-header';

export default function CollectionDetailSummary() {
  const collection: CollectionDetail = useOutletContext();
  return (
    <div>
      <Text className="text-xl font-semibold">Overview</Text>
      <div className="mt-4 grid">
        <CollectionDashboardHeader collection={collection} />
      </div>
      <div className="mt-8 grid items-center justify-center gap-4 md:grid-cols-2">
        <ProductRatingsBreakdown
          productEmissionsCategoryBreakdown={
            collection.productEmissionsCategoryBreakdown
          }
          averageEmissionsCategory={collection.averageEmissionsCategory}
          collectionUuid={collection.uuid}
        />
        <AverageLifeCycleEmissions
          averageLifeCycleStageEmissionsPerKg={
            collection.averageLifeCycleStageEmissionsPerKg
          }
        />
      </div>
    </div>
  );
}
